// Nosotros.js
import React from 'react';

const Nosotros = () => {
  return (
    <section className="py-16 px-6 bg-white text-gray-800">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl font-bold text-[#003366] mb-8 text-center">Sobre Nosotros</h1>

        <div className="mb-10">
          <h2 className="text-2xl font-semibold text-[#003366] mb-2">¿Quiénes Somos?</h2>
          <p className="text-justify">
            Inversiones BVT, C.A, es una empresa con más de 14 años de experiencia en suministros, procura, dotación, consultorías,
            construcción de obras civiles y edificaciones metálicas, sistemas eléctricos de media y baja tensión, iluminación,
            asfaltado, plantas de tratamiento de aguas, traslado de desechos petroleros y fabricación de unidades móviles (Tráiler).
            Nuestro compromiso ha resultado en mejoras significativas en la productividad de nuestros clientes.
          </p>
        </div>

        <div className="mb-10">
          <h2 className="text-2xl font-semibold text-[#003366] mb-2">Misión</h2>
          <p className="text-justify">
            La misión de Inversiones BVT, C.A, es suministrar y dotar todo lo requerido por las corporaciones, además de prestar
            servicios de consultoría, asesoría, diseño y construcción en áreas civiles, eléctricas, mecánicas y petroleras. También
            ofrecemos alquiler de tráileres móviles para espacios de trabajo, asegurando rapidez, economía y seguridad con equipos
            de alta calidad, cumpliendo con normativas de seguridad, higiene y ambiente.
          </p>
        </div>

        <div className="mb-10">
          <h2 className="text-2xl font-semibold text-[#003366] mb-2">Visión</h2>
          <p className="text-justify">
            Nuestra visión es posicionarnos como una empresa confiable a nivel nacional, brindando la mejor experiencia a nuestros
            clientes en servicios, suministros, fabricación, asesoría, diseño, logística y traslados, especialmente en locaciones y
            campamentos petroleros, con garantía de calidad y confiabilidad.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-[#003366] mb-4">Nuestros Clientes</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>A.C. Fe y Alegría</li>
            <li>Dividendos Voluntario para la Comunidad (DVC)</li>
            <li>Suministro Construcciones e Ingeniería Venezuela, C.A (SUCOINVE)</li>
            <li>IMA Alcaldía de Maracaibo</li>
            <li>Cementaciones Petroleras de Venezuela (CPVEN)</li>
            <li>Waterford Latín América</li>
            <li>Hidráulica Petrolera, C.A. (HIDRAPECA)</li>
            <li>GE Oil & Gas</li>
            <li>Oiltools de Venezuela, S.A</li>
            <li>Suministros para su Seguridad (SUPASUSCA)</li>
            <li>Tráiler Zulia, C.A</li>
            <li>Constructora las Morenas, C.A</li>
            <li>Servicios y Construcciones VP, C.A.</li>
            <li>Inversiones Construcciones y Proyectos, C.A. (INVERCONPRO)</li>
            <li>Especialista en Bombeo Electrosumergible (ESPECIALBES)</li>
            <li>Gobernación del Estado Zulia</li>
            <li>Fundación para el Desarrollo de la Infraestructura del Estado Zulia</li>
            <li>FUNDAEDUCA - Gobernación del Estado Zulia</li>
            <li>SAREZ (Relleno Sanitario)</li>
            <li>Metro de Maracaibo</li>
            <li>Gobernación del Estado Carabobo</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Nosotros;
